import { environment } from './../../environments/environment';

export class EndPointUtils {
  private allowedDomain;
  private API_URL;
  private env;
  private cloudinaryImage: string;


  constructor() {
    this.env = environment;
    this.allowedDomain = '.worldbookonline.com';
    this.API_URL = this.env.API_URL || 'https://world-of-animals.worldbookonline.com';
    this.cloudinaryImage = '//media.worldbookonline.com/image/upload/';
  }

  public getAllowedDomain() {
    return this.allowedDomain;
  }

  public getAPI() {
    return this.API_URL;
  }

  public getCloudinaryImageEP(dirPath = '', width, height, optParam, cropMode) {
    if (optParam && cropMode) {
      return `${this.cloudinaryImage}ar_1:1,f_auto,${optParam},${cropMode},w_${width},h_${height}/${dirPath}`;
    } else {
      return `${this.cloudinaryImage}ar_1:1,f_auto,w_${width},h_${height}/${dirPath}`;
    }
  }

  /**
   * Return Environmaent Variable
   */
  public legacyRedirection(dirPath = '') {
    // for legacy this method will be used. It will return '//' + window.location.host + path
    return `${this.env.legacyRedirection}${dirPath}`;
  }

  public sortAscOrder(array, value) {
    array.sort((a, b) => {
      return ((a[value].toLowerCase() < b[value].toLowerCase()) ? -1 : ((a[value].toLowerCase() > b[value].toLowerCase()) ? 1 : 0));
    });
    return array;
  }

  public parseArray(array) {
    return JSON.parse(JSON.stringify(array));
  }

  public linkToResource(appName, resourceLink) {
    let link = `//${window.location.host}/${appName}`;
    if (resourceLink) {
      link = `//${window.location.host}/${appName}/${resourceLink}`;
    }
    return link;
  }

  public getAppLanguage() {
    const value = localStorage.getItem('appLanguage');
    return value;
  }

  public getLocalStorage(val) {
    const value = localStorage.getItem(val);
    return value;
  }

  public getCurrentYear() {
    const date = new Date();
    const currentYear = date.getFullYear();
    return currentYear;
  }
}
